<template>
  <span
    :class="['zg-product-icon', {
      [`zg-product-icon--size-${size}`]: size
    }]"
  >
    <component
      :is="product"
      v-if="product"
    />
  </span>
</template>

<script>
  export default {
    name: 'ZgProductIcon',
    components: {
      AccidentInsurance: () => import('./icons/AccidentInsurance.vue'),
      AtvLoan: () => import('./icons/AtvLoan.vue'),
      BoatInsurance: () => import('./icons/BoatInsurance.vue'),
      BoatLoan: () => import('./icons/BoatLoan.vue'),
      CarAddOns: () => import('./icons/CarAddOns.vue'),
      CarInsurance: () => import('./icons/CarInsurance.vue'),
      CarLoan: () => import('./icons/CarLoan.vue'),
      CompanyCarInsurance: () => import('./icons/CompanyCarInsurance.vue'),
      CompanyElectricity: () => import('./icons/CompanyElectricity.vue'),
      CompanyInsurance: () => import('./icons/CompanyInsurance.vue'),
      ConsolidateLoan: () => import('./icons/ConsolidateLoan.vue'),
      ConsumerLoan: () => import('./icons/ConsumerLoan.vue'),
      CustomerSupport: () => import('./icons/CustomerSupport.vue'),
      DiseaseAndAccidentInsurance: () => import('./icons/DiseaseAndAccidentInsurance.vue'),
      DogInsurance: () => import('./icons/DogInsurance.vue'),
      Electricity: () => import('./icons/Electricity.vue'),
      FaqCustomerSupport: () => import('./icons/FaqCustomerSupport.vue'),
      HomeInsurance: () => import('./icons/HomeInsurance.vue'),
      HouseInsurance: () => import('./icons/HouseInsurance.vue'),
      IncomeInsurance: () => import('./icons/IncomeInsurance.vue'),
      Insurance: () => import('./icons/Insurance.vue'),
      JetSkiInsurance: () => import('./icons/JetSkiInsurance.vue'),
      LifeInsurance: () => import('./icons/LifeInsurance.vue'),
      LightTruckInsurance: () => import('./icons/LightTruckInsurance.vue'),
      LoanPromise: () => import('./icons/LoanPromise.vue'),
      McInsurance: () => import('./icons/McInsurance.vue'),
      Mortgage: () => import('./icons/Mortgage.vue'),
      MortgageExtended: () => import('./icons/MortgageExtended.vue'),
      MotorhomeInsurance: () => import('./icons/MotorhomeInsurance.vue'),
      MotorhomeLoan: () => import('./icons/MotorhomeLoan.vue'),
      SavingTips: () => import('./icons/SavingTips.vue'),
      SellingSolarSurplus: () => import('./icons/SellingSolarSurplus.vue'),
      SmeLoan: () => import('./icons/SmeLoan.vue'),
      SnowMobileInsurance: () => import('./icons/SnowMobileInsurance.vue'),
      Store: () => import('./icons/Store.vue'),
      WeekendCottageInsurance: () => import('./icons/WeekendCottageInsurance.vue')
    },
    props: {
      product: {
        type: String,
        required: true,
        validator: value => [
          'accident-insurance',
          'atv-loan',
          'boat-insurance',
          'boat-loan',
          'car-add-ons',
          'car-insurance',
          'car-loan',
          'company-car-insurance',
          'company-electricity',
          'company-insurance',
          'consolidate-loan',
          'consumer-loan',
          'customer-support',
          'disease-and-accident-insurance',
          'dog-insurance',
          'electricity',
          'faq-customer-support',
          'home-insurance',
          'house-insurance',
          'income-insurance',
          'insurance',
          'jet-ski-insurance',
          'life-insurance',
          'light-truck-insurance',
          'loan-promise',
          'mc-insurance',
          'mortgage',
          'mortgage-extended',
          'motorhome-insurance',
          'motorhome-loan',
          'saving-tips',
          'selling-solar-surplus',
          'sme-loan',
          'snow-mobile-insurance',
          'store',
          'weekend-cottage-insurance'
        ].includes(value)
      },
      size: {
        type: String,
        required: false,
        default: 'medium',
        validator: value => [
          'xxxsmall',
          'xxsmall',
          'xsmall',
          'small',
          'medium',
          'large',
          'xlarge'
        ].includes(value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-product-icon {
    display: inline-flex;
    justify-content: center;
    align-items: center;

    ::v-deep svg {
      color: color(brand-500);
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
    }
  }

  // ? ----------------------------------------------------------------------
  // sizes
  // ? ----------------------------------------------------------------------

  .zg-product-icon--size-xxxsmall {
    width: rem(64px);
    height: rem(64px);
  }

  .zg-product-icon--size-xxsmall {
    width: rem(80px);
    height: rem(80px);
  }

  .zg-product-icon--size-xsmall {
    width: rem(96px);
    height: rem(96px);
  }

  .zg-product-icon--size-small {
    width: rem(112px);
    height: rem(112px);
  }

  .zg-product-icon--size-medium {
    width: rem(128px);
    height: rem(128px);
  }

  .zg-product-icon--size-large {
    width: rem(144px);
    height: rem(144px);
  }

  .zg-product-icon--size-xlarge {
    width: rem(160px);
    height: rem(160px);
  }
</style>
